import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';

export const Animation: LazyComponent<{ width?: string; height?: string }> = lazyWithNullFallback(
  () => import('./logo')
);
